import { Root } from './pages';

export default {
  key: 'root',
  hasSidebar: false,
  exact: true,
  path: '/',
  component: Root,
};
